import React, { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";
import {
  useBackProduct,
  useDeleteProduct,
  useGetLadderPorduct,
  useGetMyProductList,
  useShareProduct,
  useShareProducts,
} from "../../../../hooks/useContent";
import { Container } from "../../../../theme/GlobalStyle";
import { sumPrice } from "../../../../utils/sumPrice";
import Button from "../../../Button/Button";
import { Table } from "../../../Table/Table";
import { MdDeleteForever } from "react-icons/md";
import { FiEdit, FiShare } from "react-icons/fi";
import { AiOutlineRollback } from "react-icons/ai";
import { BsLadder } from "react-icons/bs";
import { useQueryClient } from "react-query";
import ConfirmDialog from "../../../Dialog/ConfirmDialog";
import { Link } from "react-router-dom";
import Typography from "../../../Typography/Typography";
import Loading from "../../../Loadings/LoadingTable";
import { RenderTooltip } from "../../../Tooltip/Tooltip";
import BreadCrumb from "../../../BreadCrumb/BreadCrumb";
const MyProduct = () => {
  const headerTitle = [
    "_",
    "#",
    "عنوان محصول",
    "دسته بندی",
    "قیمت یک عدد",
    "تعداد در جین",
    "قیمت کل",
    "برند",
    "تعداد موجودی",
    "کد محصول",
    "عملیات",
  ];
  const [checked, setChecked] = useState("");
  const [Search, setSearch] = useState("");
  const [status, setStatus] = useState({
    title: "",
    status: "",
    id: "",
  });
  const [showDialog, setShowDialog] = useState(false);
  const {
    data: productList,
    isLoading: loadingProduct,
    hasNextPage,
    fetchNextPage,
  } = useGetMyProductList(Search, {
    status: "Barci",
  });

  const pageCount = productList?.pages[0]?.data?.count;
  const queryClient = useQueryClient();

  const { mutateAsync: deleteProduct } = useDeleteProduct();

  // handle delete
  const handleDelete = async (id) => {
    await deleteProduct(id);
    setShowDialog(false);
  };

  // handle ladder
  const { mutateAsync: updateLadder } = useGetLadderPorduct();

  const handleLadder = async (productId) => {
    await updateLadder(productId);
    setShowDialog(false);
  };

  // handle share product
  const { mutateAsync: shareProduct } = useShareProduct();

  const handleShare = async (id) => {
    await shareProduct(id);
    setChecked("");
    setShowDialog(false);
  };

  // handle share products
  const { mutateAsync: shareProducts } = useShareProducts();
  const handleShareProducts = async (checkData) => {
    await shareProducts(checkData);
    setShowDialog(false);
  };

  // handle back product

  const { mutateAsync: goBackProduct } = useBackProduct();

  const handleBack = async (productId) => {
    const data = {
      StatusProducts: "Back",
      IdProducts: productId,
    };
    await goBackProduct(data);
    queryClient.invalidateQueries("fetch-myProduct-list", 1, "Barci");
    setShowDialog(false);
  };

  const handleConfirmModal = (productId) => {
    switch (status.status) {
      case "delete":
        return handleDelete(productId);
      case "edit":
        return alert("Hello");
      case "share":
        return handleShare(productId);
      case "back":
        return handleBack(productId);
      case "ladder":
        return handleLadder(productId);
      default:
        return;
    }
  };

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;
        if (hasNextPage) await fetchNextPage();
        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);

  let i = 0;

  const items = productList ? (
    productList?.pages?.map((page) =>
      page?.data?.Products?.map((item) => (
        <>
          <tr key={item.IdProducts}>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                <input
                  type="checkbox"
                  value={item.IdProducts}
                  onChange={() => {
                    setChecked((prevState) => {
                      if (prevState.includes(item.IdProducts)) {
                        return prevState.filter((st) => st !== item.IdProducts);
                      } else {
                        return [...prevState, item.IdProducts];
                      }
                    });
                  }}
                />
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {(i += 1)}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item.NameProducts}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.first_category?.NameCategories}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.PriceProducts}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.NumberInJeans}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {sumPrice(
                  item?.NumberSellProducts,
                  item?.NumberInJeans,
                  item?.PriceProducts
                )}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.brand?.NameBrands}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.NumberInStock}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.CodeProducts}
              </span>
            </td>
            <td>
              <ButtonContainer>
                <RenderTooltip title="حذف محصول">
                  <Button
                    size="12px"
                    bgColor="#C82333"
                    small="40px"
                    color="#fff"
                    onclick={() => {
                      setShowDialog(true);
                      setStatus({
                        title: "آیا از حذف این محصول مطمئن هستید ؟",
                        status: "delete",
                        id: item?.IdProducts,
                      });
                    }}
                  >
                    <MdDeleteForever size={25} />
                  </Button>
                </RenderTooltip>
                <RenderTooltip title="ویرایش محصول">
                  <Button
                    size="12px"
                    bgColor="#0D6EFD"
                    small="40px"
                    color="#fff"
                    className="mr-2"
                  >
                    <Link
                      to={`/dashboard/content-controller/products/editProduct?productId=${item?.IdProducts}`}
                    >
                      <Typography>
                        <FiEdit color="#fff" size={20} />
                      </Typography>
                    </Link>
                  </Button>
                </RenderTooltip>
                <RenderTooltip title="انتشار محصول">
                  <Button
                    size="12px"
                    bgColor="#17A2B8"
                    small="40px"
                    color="#fff"
                    className="mr-2"
                    onclick={
                      () => {
                        setShowDialog(true);
                        setStatus({
                          title: "آیا از انتشار این محصول مطمئن هستید ؟",
                          status: "share",
                          id: [item?.IdProducts],
                        });
                      }
                      //  handleShare([item?.IdProducts])
                    }
                  >
                    <FiShare size={20} />
                  </Button>
                </RenderTooltip>
                <RenderTooltip title="بازگشت محصول">
                  <Button
                    size="12px"
                    bgColor="#FFC107"
                    small="40px"
                    color="#fff"
                    className="mr-2"
                    onclick={() => {
                      setShowDialog(true);
                      setStatus({
                        title: "آیا از بازگشت این محصول مطمئن هستید ؟",
                        status: "back",
                        id: item?.IdProducts,
                      });
                    }}
                  >
                    <AiOutlineRollback size={20} />
                  </Button>
                </RenderTooltip>
                {/* <RenderTooltip title="نردبان کردن محصول">
                  <Button
                    size="12px"
                    bgColor="#868E96"
                    small="40px"
                    color="#fff"
                    className="mr-2"
                    onclick={() => {
                      setShowDialog(true);
                      setStatus({
                        title: "آیا از نربان کردن این محصول مطمئن هستید ؟",
                        status: "ladder",
                        id: item?.IdProducts,
                      });
                    }}
                  >
                    <BsLadder size={20} />
                  </Button>
                </RenderTooltip> */}
              </ButtonContainer>
            </td>
            <td></td>
          </tr>
        </>
      ))
    )
  ) : (
    <Loading />
  );

  if (loadingProduct) {
    return <Loading />;
  }

  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="محصولات"
        num3="محصولات در حال بررسی"
        href1="/dashboard/content-controller"
        href2="/dashboard/content-controller/products"
      />
      <Container>
        <Table
          title={`لیست محصولات درحال بررسی (${pageCount || ""})`}
          headerTitle={headerTitle}
          items={items}
          setSearch={setSearch}
          shareBtn={
            <Button
              small="100px"
              bgColor="#17A2B8"
              color="#fff"
              onclick={() => handleShareProducts(checked)}
            >
              منتشر کردن
            </Button>
          }
        />
        <ConfirmDialog
          show={showDialog}
          title={status.title}
          handleClose={() => setShowDialog(false)}
          onSuccess={() => handleConfirmModal(status.id)}
          successTitle="تایید"
          feildTitle="منصرف شدم"
        />
      </Container>
    </>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  gap: 1rem;
`;

export default MyProduct;
